// @ts-nocheck

import React, { useMemo } from 'react';
import styled from 'styled-components';

import Formatter from '../../i18n/formatter';
import { getCurrency, __ } from '../../i18n/l10n';
import type { BasketEligibleBoosterState } from '../../states/basket';
import theme from '../../styled-components/dark';

const Wrap = styled.div``;

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 90%;
`;

const Value = styled.div`
  font-weight: bold;
  font-size: 1.1em;
`;

const BoosterSentenceRow = styled.div`
  line-height: 1.1em;
  font-size: 0.9em;
  padding: 5px 0;
  color: ${theme.BasketSummary.boosterSentenceColor};
`;

type BasketBoostersProps = {
  className?: string;
  readOnly: boolean;
  isCombined: boolean;
  isSystem: boolean;
  eligibleBooster: BasketEligibleBoosterState;
  boosterGain: number;
};

const BasketBoosters = ({
  className,
  readOnly,
  isCombined,
  isSystem,
  eligibleBooster,
  boosterGain,
}: BasketBoostersProps) => {
  const eligibleBoosterValue = useMemo(
    () => (eligibleBooster && eligibleBooster.next ? Formatter.formatPercent((eligibleBooster.next - 1) * 100) : null),
    [eligibleBooster],
  );

  const boosterCombinedSentence =
    !readOnly && eligibleBooster?.current !== eligibleBooster?.next && eligibleBooster?.next > 1;
  const showBoosterCombined = isCombined && (eligibleBooster?.current > 1 || boosterCombinedSentence);
  const showBoosterSystem = isSystem && eligibleBooster && boosterGain > 0;

  return showBoosterCombined || showBoosterSystem ? (
    <Wrap className={className}>
      {showBoosterCombined ? (
        <>
          {eligibleBooster.current > 1 ? (
            <Row>
              <span>{`${__('Winnings')} ${__('Combo booster')} ${Formatter.formatPercent(
                (eligibleBooster.current - 1) * 100,
              )}`}</span>
              <Value>{Formatter.formatNumber(boosterGain, getCurrency())}</Value>
            </Row>
          ) : null}
          {boosterCombinedSentence ? (
            <BoosterSentenceRow>
              {eligibleBooster.live
                ? __('Add an In-Play selection to get a %1$s bonus', eligibleBoosterValue)
                : __('Add one selection to get a %1$s bonus', eligibleBoosterValue)}
            </BoosterSentenceRow>
          ) : null}
        </>
      ) : null}
      {showBoosterSystem ? (
        <Row>
          <span>{`${__('Winnings')} ${__('Combo booster')}`}</span>
          <Value>{Formatter.formatNumber(boosterGain, getCurrency())}</Value>
        </Row>
      ) : null}
    </Wrap>
  ) : null;
};

export default BasketBoosters;
